var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-picker-container control"},[_c('input',{ref:"date-picker",staticClass:"input",attrs:{"id":"date-picker","type":"text"}})])}
var staticRenderFns = []

export { render, staticRenderFns }